// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g4-a";
export var fulfillmentFormRail = "_g4-9";
export var headerTitleRow = "_g4-c";
export var orderDetailsWrapper = "_g4-7";
export var orderLinkTrigger = "_g4-2";
export var paymentInformationGrid = "_g4-h";
export var paymentSummaryColumn = "_g4-i";
export var shipmentContainer = "_g4-b";
export var shipmentDetailsMainPane = "_g4-8";
export var shipmentNavigationCard = "_g4-5";
export var shipmentNavigationRail = "_g4-3";
export var shipmentNavigationRailHeader = "_g4-4";
export var shipmentSummaryFact = "_g4-e";
export var shipmentSummaryGrid = "_g4-d";
export var shipmentSummaryMetadataRow = "_g4-f";
export var shipmentSummaryTags = "_g4-g";
export var shipmentWorkspace = "_g4-0";
export var shipmentWorkspaceContent = "_g4-6";
export var shipmentWorkspaceHeader = "_g4-1";